import React from 'react'
import styled from 'styled-components'
import Container from './Container'
import Memberz from '../images/favicon.png'

const Wrapper = styled.div`
box-sizing: border-box;
margin-top: 5rem;
h2{
margin: 0px 0px 1rem;
min-width: 0px;
font-weight: 700;
letter-spacing: -0.015em;
line-height: 1.3;
margin-bottom: 5rem;
}
.members-wrapper {
box-sizing: border-box;
display: flex;
flex-flow: row wrap;
margin-top: 1.25rem;
margin-bottom: 1.25rem;
}
.member {
box-sizing: border-box;
display: flex;
flex-flow: row wrap;
-webkit-box-pack: center;
justify-content: center;
margin-top: 3.5rem;
margin-bottom: 3.5rem;
width: 47%;
margin-right: 3%;
@media screen and (max-width: 600px)  {
    width: 100%;
    }
}
.member-left {
box-sizing: border-box;
display: flex;
flex-flow: column nowrap;
width: 20%;
@media screen and (max-width: 600px)  {
    width: 10%;
    }
}
.image-wrapper {
position: relative;
overflow: hidden;
}
.member-right {
box-sizing: border-box;
margin-left: 5%;
width: 75%;
}
.member-header {
box-sizing: border-box;
margin: 0px 0px 1rem;
min-width: 0px;
font-weight: 600;
line-height: 0.8em !important;
}
img {
box-sizing: border-box;
width: 100%;
padding-bottom: 20%;
}
`


function Hakkimda() {
    return (
        <Container>
            <Wrapper>
                <h2>Hakkımızda</h2>
                <p>
                Ayazsan İnşaat, sizin için uygun fiyatlı özel yapı fırsatları sunar. Yüksek kaliteli, çok yönlü ve dayanıklı malzemelerimizle ihtiyaçlarınız için en iyi inşaat hizmetini alacağınıza emin olabilirsiniz. İnşaat sektörünün her alanında uzmanız.
                </p>
                <div className='members-wrapper'>
                    <div className='member'>
                        <div className='member-left'>
                            <div className='image-wrapper'>
                                <img src={Memberz} alt='Ayazsan İnşaat Konya' />
                            </div>
                        </div>
                        <div className='member-right'>
                            <h3>Konya İnşaat</h3>
                            <p>"Ayazsan İnşaat" altyapı, iş gücü ve de bilgi birikimine sahip olmanın verdiği güvenle; <strong>Konya İnşaat</strong> sektöründe birlikte yürüyebileceği iş projelerine girmek üzere hareket etmeye daima hazır.</p>
                        </div>
                    </div>
                    <div className='member'>
                        <div className='member-left'>
                            <div className='image-wrapper'>
                                <img src={Memberz} alt='Ayazsan Konya İnşaat' />
                            </div>
                        </div>
                        <div className='member-right'>
                            <h3>Konya Anahtar Teslim İnşaat</h3>
                            <p>“Müşteriden Dostluğa Giden Yol” prensibiyle projelerin tamamlanmasından sonra da müşterilerinin ihtiyaç ve beklentilerini karşılamaya hazır olduğunu göstermeye önem verir.</p>
                        </div>
                    </div>
                    <div className='member'>
                        <div className='member-left'>
                            <div className='image-wrapper'>
                                <img src={Memberz} alt='Ayazsan Konya İnşaat' />
                            </div>
                        </div>
                        <div className='member-right'>
                            <h3>Konya Anahtar Teslim Villa</h3>
                            <p>"Kaliteli Hizmet" prensibiyle iş ve çözüm üreten Ayazsan İnşaat gelecek 10 yılında Türkiye'nin değil dünyanın sayılı <strong>Anahtar Teslim Villa</strong> şirketlerinden biri olmak üzerine kuruldu.	</p>
                        </div>
                    </div>
                    <div className='member'>
                        <div className='member-left'>
                            <div className='image-wrapper'>
                                <img src={Memberz} alt='Konya İnşaat' />
                            </div>
                        </div>
                        <div className='member-right'>
                            <h3>Konya En İyi İnşaat Firması</h3>
                            <p>Ayazsan İnşaat, projelendirme aşamasından tüm uygulamanın yapılarak anahtar teslimine kadar inşaat sektörünün tüm alanlarında uzman kadrosu ile hizmet vermektedir.</p>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </Container>
    )
}

export default Hakkimda
